<div *ngIf="!!data">
  <div class="card" *ngFor="let row of data; index as i; trackBy: trackByFn">
    <div class="card-body">
      <div class="card-title row">
        <div class="col">
          <h5 class="m-0">{{ row.poNo }}</h5>
        </div>
        <div class="col-auto ml-auto">
          <button type="button" class="btn btn-primary">
            <span translate>DOWNLOAD</span>
            <i class="fas fa-file-download ml-1"></i>
          </button>
          <button type="button" class="btn btn-secondary ml-1">
            <span translate>CONFIRM</span>
            <i class="fas fa-check ml-1"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-3">
          <lib-gung-text-input
            gungTranslate="ITEM_NUMBER"
            renderStatic="true"
            [ngModel]="row.artNr"
            labelBold="true"
          ></lib-gung-text-input>
          <lib-gung-date-output
            [gungTranslate]="'REQUEST_DATE'"
            [value]="row.requestDate"
            labelBold="true"
          ></lib-gung-date-output>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="form-group pb-1">
            <label class="mb-0 font-weight-bold" translate>PRICE</label>
            <lib-price [price]="row.pris" [currency]="row.currency" class="form-control-plaintext p-0"></lib-price>
          </div>
          <div class="form-group pb-1">
            <label class="mb-0 font-weight-bold" translate>TOTAL_PRICE</label>
            <lib-price [price]="row.totalPris" [currency]="row.currency" class="form-control-plaintext p-0"></lib-price>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <lib-gung-text-input
            gungTranslate="QUANTITY_ORDERED"
            renderStatic="true"
            [ngModel]="row.bestant | number: '1.0-2'"
            labelBold="true"
          ></lib-gung-text-input>
          <!-- <lib-gung-text-input gungTranslate="DESCRIPTION" renderStatic="true" [ngModel]="row.artDesc" labelBold="true"></lib-gung-text-input> -->
        </div>
        <div class="col-xs-12 col-md-3">
          <lib-gung-text-input
            gungTranslate="QUANTITY_CONFIRM"
            [placeholder]="row.bestant | number: '1.0-2'"
            labelBold="true"
          ></lib-gung-text-input>
          <lib-delivery-date-picker
            label="CONFIRM_READY_DATE"
            (selectedDate)="dateSelected($event)"
            labelBold="true"
          ></lib-delivery-date-picker>
        </div>
        <div class="col-12">
          <lib-gung-text-area-input
            gungTranslate="DESCRIPTION"
            renderStatic="true"
            rowsNumber="1"
            [ngModel]="row.artDesc"
            labelBold="true"
            blockResize="true"
          ></lib-gung-text-area-input>
          <lib-gung-text-area-input
            gungTranslate="EXTERNAL_TEXT"
            renderStatic="true"
            rowsNumber="1"
            [ngModel]="row.extText"
            labelBold="true"
            blockResize="true"
          ></lib-gung-text-area-input>
        </div>
      </div>
    </div>
  </div>
</div>
